module.exports = __webpack_public_path__ + "static/media/LOR_Dr.Roy_BGSU.18c7d3db.pdf";